import axiosInstance from '@/core/api'
import {
	GetAdminMeResponse,
	GetDomainsResponse,
	AttachDomainRequest,
	DetachDomainRequest,
	AttachDomainResponse,
	DetachDomainResponse,
	SearchDomainsRequest,
	SearchDomainsResponse,
	DomainQuotaResponse,
	BuyDomainRequest,
	BuyDomainResponse,
} from '@/modules/admin/type'
import {
	CreateOperatorRequest,
	GetOperatorsRequest,
	GetOperatorsResponse,
	UpdateOperatorRequest,
	OperatorDataResponse,
} from '@/modules/manage-operator/types'

export const getAdminMe = async (): Promise<GetAdminMeResponse> => {
	const response = await axiosInstance.get<GetAdminMeResponse>('/admin/me')
	return response.data
}

export const getOperators = async (
	payload: GetOperatorsRequest,
): Promise<GetOperatorsResponse> => {
	const response = await axiosInstance.get<GetOperatorsResponse>(
		'/admin/get-operators',
		{ params: payload },
	)
	return response.data
}

export const getOperatorById = async (
	operatorId: string,
): Promise<OperatorDataResponse> => {
	const response = await axiosInstance.get<OperatorDataResponse>(
		`/admin/get-operator/${operatorId}`,
	)
	return response.data
}

export const createOperator = async (
	request: CreateOperatorRequest,
): Promise<OperatorDataResponse> => {
	const response = await axiosInstance.post<OperatorDataResponse>(
		'/admin/create-operators',
		request,
	)
	return response.data
}

export const updateOperator = async (
	operatorId: string,
	payload: UpdateOperatorRequest,
): Promise<OperatorDataResponse> => {
	const response = await axiosInstance.patch<OperatorDataResponse>(
		`/admin/update-operators/${operatorId}`,
		payload,
	)
	return response.data
}

// Domain Management Services
export const getDomains = async (): Promise<GetDomainsResponse> => {
	const response = await axiosInstance.get<GetDomainsResponse>('/admin/domains')
	return response.data
}

export const attachDomain = async (
	payload: AttachDomainRequest,
): Promise<AttachDomainResponse> => {
	const response = await axiosInstance.post<AttachDomainResponse>(
		'/admin/domains/attach-domain',
		payload,
	)
	return response.data
}

export const detachDomain = async (
	payload: DetachDomainRequest,
): Promise<DetachDomainResponse> => {
	const response = await axiosInstance.post<DetachDomainResponse>(
		'/admin/domains/detach-domain',
		payload,
	)
	return response.data
}

// Buy Domain Services
export const searchDomains = async (
	payload: SearchDomainsRequest,
): Promise<SearchDomainsResponse> => {
	const response = await axiosInstance.get<SearchDomainsResponse>(
		'/admin/domains/search',
		{ params: payload },
	)
	return response.data
}

export const getDomainQuota = async (): Promise<DomainQuotaResponse> => {
	const response = await axiosInstance.get<DomainQuotaResponse>(
		'/admin/domains/quota',
	)
	return response.data
}

export const buyDomain = async (
	payload: BuyDomainRequest,
): Promise<BuyDomainResponse> => {
	const response = await axiosInstance.post<BuyDomainResponse>(
		'/admin/domains/buy',
		payload,
	)
	return response.data
}
